import React from 'react';
import { FormSections, FormSubSections, ProgramContainer } from "../entities/formTemplateDataType"
import { SubSectionComponent } from "../runtimeComponent/SubSectionComponent";
import { SelectButton } from 'primereact/selectbutton';
import HelmetComponent from '../commonComponent/HelmetComponent';
import StepIndicator from '../runtimeComponent/subComponent/step-indicator/StepIndicator';
import { ErrorAlertsComponent } from '../runtimeComponent/odsCalloutBox/ErrorAlertsComponent';
import SectionUtils from '../utilities/SectionUtils';
import { isRuntime } from '../config';
import { colour } from '../theme';
import Utils from '../utilities/Utils';
import { CustomizedSummaryComponent } from "../runtimeComponent/summary/CustomizedSummaryComponent";
import DataUtils from '../utilities/DataUtils';


interface Props {
    programContainer: ProgramContainer;
    stepIndex: number;
    isEng: boolean;
    callBackLang?: (isEng: boolean) => void;
    callback?:(programContainer: ProgramContainer) => void;
    onBusyChange?: (isBusy: boolean) => void;
}

interface State {
    activeSection: FormSections;
    validationErrMsg: any[];
    showReview: boolean;
    showForm: boolean;
    programContainer: ProgramContainer;
    confirmationVisible: boolean;
    summaryVisible: boolean;
    transactionId: string;
    submissionError: boolean;
    showDownloadSummary: boolean;
    applicationType: string;
    renewType?: string;
}

export class FormStepPreviewComponent extends React.Component<Props, State> {
    errorRef: React.RefObject<HTMLDivElement>;

    constructor(props: Props) {
        super(props);

        const sections = this.props.programContainer.ListOfFormSections || [];
        this.state = {
            activeSection: sections[this.props.stepIndex],
            validationErrMsg: [],
            showReview: false,
            showForm: true,
            programContainer: this.props.programContainer,
            confirmationVisible: false,
            summaryVisible: true,
            transactionId: '',
            submissionError: false,
            showDownloadSummary: false,
            applicationType: '',
            renewType: undefined
        };

        this.initializeSection(this.props.programContainer);
        this.errorRef = React.createRef();
    }

    private handleSummaryState = (
        confirmationVisible: boolean,
        summaryVisible: boolean,
        transactionId: string,
        submissionError: boolean,
        showDownloadSummary: boolean,
        applicationType: string,
        renewType: string
    ) => {
        this.setState({
            confirmationVisible,
            summaryVisible,
            transactionId,
            submissionError,
            showDownloadSummary,
            applicationType,
            renewType
        });
    };

    initializeSection(programContainer: ProgramContainer) {
        programContainer.ListOfFormSections?.forEach((section: FormSections) => {
            section.findSubsectionByTitle = (subsectionTitle: string) =>
                section.ListOfFormSubSections?.find(subsection => subsection.ENUTitle === subsectionTitle || subsection.FRATitle === subsectionTitle);
        });
    }

    componentDidMount = () => {
          DataUtils.initDuplicateSections(this.props.programContainer);
    }

    componentDidUpdate(prevProps: Props) {
        if (prevProps.stepIndex !== this.props.stepIndex) {
            const sections = this.props.programContainer.ListOfFormSections || [];
            this.setState({
                activeSection: sections[this.props.stepIndex],
                validationErrMsg: [],
                programContainer: this.props.programContainer
            });
        }

        if (prevProps.programContainer !== this.props.programContainer) {
            this.initializeSection(this.props.programContainer);
            this.setState({
                programContainer: this.props.programContainer
            });
        }
    }

    handleFormCallback = (updatedProgramContainer: ProgramContainer) => {
        this.setState({
            programContainer: updatedProgramContainer
        }, () => {
            if (this.props.callback) {
                this.props.callback(updatedProgramContainer);
            }
        });
    }

    handleElementCallback = (updatedProgramContainer: ProgramContainer) => {
        this.setState({ 
            programContainer: updatedProgramContainer 
        }, () => {
            const sections = updatedProgramContainer.ListOfFormSections || [];
            this.setState({
                activeSection: sections[this.props.stepIndex]
            });

            if (this.props.callback) {
                this.props.callback(updatedProgramContainer);
            }
        });
    }

    handleSummaryStepIndex = (index: number | string) => {
        const sections = this.state.programContainer.ListOfFormSections || [];
        let targetIndex: number | undefined;

        if (typeof index === 'number') {
            targetIndex = index;
        } else {
            targetIndex = sections.findIndex(section => section.ENUTitle === index);
        }

        if (targetIndex !== undefined && targetIndex >= 0 && sections[targetIndex]) {
            this.setState({
                activeSection: sections[targetIndex],
                validationErrMsg: [],
                showReview: false,
                showForm: true
            });
        }
    };

    sectionOptionsFieldValue = (formSubSection: FormSubSections, optionsFieldValue: Map<string, string>) => {
        formSubSection.ListOfFormSectionElements.forEach(element => {
            if (element.Datatype === 'Row') {
                if (element.subSectionList && element.subSectionList.length > 0) {
                    element.subSectionList.forEach(subSection => {
                        this.sectionOptionsFieldValue(subSection, optionsFieldValue)
                    })
                }
            }
            if (["RadioButton", "CheckGroup", "Dropdown"].includes(element.Datatype)) {
                if (!Utils.isNullOrEmpty(element.LoadBindName) && !Utils.isNullOrEmpty(element.Value)) {
                    optionsFieldValue.set(element.LoadBindName, element.Value);
                } else {
                    optionsFieldValue.set(element.LoadBindName, '');
                }
            }
        })
    }

    stepperHeaderGeneration = () => {
        const currentSection = this.state.activeSection;
        const options = ["English", "French"];
        const displayErrorComponent = this.state.validationErrMsg.filter(p => p.Visible).length > 0;
        let StepperHeader = [];

        if (!currentSection) return null;

        switch (this.state.programContainer.displayForm) {
            case 'hiddenStepper':
                if (!currentSection?.IsTechErrorPage) {
                    const topPositionFields = SectionUtils.getFieldsAboveTitle(currentSection);
                    StepperHeader.push(
                        <div key="stepper-header" style={{
                            width: '100%',
                            maxWidth: '1200px',
                            margin: '0 auto',
                            padding: '0 20px'
                        }}>
                            <div style={{ display: isRuntime() !== 'false' || this.state.programContainer.EnglishOnly ? 'none' : 'flex', justifyContent: 'end', marginBottom: '20px' }}>
                                <SelectButton
                                    value={this.props.isEng ? 'English' : 'French'}
                                    onChange={(e) => this.props.callBackLang && this.props.callBackLang(e.value == 'English')}
                                    options={options}
                                />
                            </div>

                            <div>
                                <div style={{ display: currentSection?.IsInfoPage || currentSection?.CustomizedReviewPage || currentSection?.IsTechErrorPage || currentSection?.IsConfirmationPage ? "none" : "block" }}>
                                    <StepIndicator
                                        withbackbtn={true}
                                        sectionSequence={this.props.stepIndex}
                                        title="Back"
                                        section={currentSection}
                                        isEng={this.props.isEng}
                                        topNavigation={this.state.programContainer.TopNavigation}
                                        showReview={this.state.showReview}
                                        leftButtons={null}
                                        rightButtons={null}
                                        callback={() => { }}
                                    />
                                </div>

                                <div style={{ display: displayErrorComponent ? "block" : "none" }} tabIndex={-1} ref={this.errorRef}>
                                    <ErrorAlertsComponent errorMsgList={this.state.validationErrMsg} isEng={this.props.isEng} />
                                </div>

                                {!currentSection?.TitleInStepIndicator && (
                                    <>
                                        <h1 style={{ display: currentSection?.IsTerminationPage || currentSection.CustomizedReviewPage ? "none" : "block" }} className="ontario-h1 ontario-margin-bottom-0-! div-override-margin">
                                            {this.props.isEng ? currentSection?.ENUTitle : currentSection?.FRATitle}
                                        </h1>
                                        <div style={{ display: currentSection?.IsTerminationPage || currentSection.CustomizedReviewPage ? "none" : "block" }}
                                            className={!currentSection?.IsTerminationPage && currentSection?.ENUDescription ? "ontario-margin-top-24-!" : ""}>
                                            {this.props.isEng ? currentSection?.ENUDescription : currentSection?.FRADescription}
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    );
                }
                break;

            case 'hiddenStepperWithSectionTitle':
                if (!currentSection.NotStep) {
                    StepperHeader.push(
                        <div key="stepper-header-with-title" className="ontario-margin-top-16-!" style={{
                            width: '100%',
                            maxWidth: '1200px',
                            margin: '0 auto',
                            padding: '0 20px'
                        }}>
                            <div style={{ display: isRuntime() !== 'false' || this.props.programContainer.EnglishOnly ? 'none' : 'flex', justifyContent: 'end', marginBottom: '20px' }}>
                                <SelectButton
                                    value={this.props.isEng ? 'English' : 'French'}
                                    onChange={(e) => this.props.callBackLang && this.props.callBackLang(e.value == 'English')}
                                    options={options}
                                />
                            </div>

                            <div>
                                <span className="ontario-h4" style={{ display: !currentSection?.IsFrontPage && !currentSection?.IsTerminationPage && !currentSection?.CustomizedReviewPage && !currentSection?.IsTechErrorPage ? "block" : "none" }}>
                                    Step&nbsp;
                                    {this.props.stepIndex + 1}&nbsp;of&nbsp;
                                    {this.props.programContainer.ListOfFormSections.filter(p => !p.IsFrontPage && !p.IsTerminationPage && !p.CustomizedReviewPage && p.Visible).length}:&nbsp;
                                    {this.props.isEng ? currentSection?.ENUTitle : currentSection?.FRATitle}
                                </span>
                                <hr className="ontario-margin-top-0-! ontario-margin-bottom-36-!" />
                            </div>

                            <div style={{ display: displayErrorComponent ? "block" : "none" }}>
                                <ErrorAlertsComponent errorMsgList={this.state.validationErrMsg} isEng={this.props.isEng} />
                            </div>
                        </div>
                    );
                }
                break;

            default:
                StepperHeader.push(
                    <div key="default-header" style={{
                        width: '100%',
                        maxWidth: '1200px',
                        margin: '0 auto',
                        padding: '0 20px'
                    }}>
                        <div style={{ display: isRuntime() !== 'false' || this.state.programContainer.EnglishOnly ? 'none' : 'flex', justifyContent: 'end', marginBottom: '20px' }}>
                            <SelectButton
                                value={this.props.isEng ? 'English' : 'French'}
                                onChange={(e) => this.props.callBackLang && this.props.callBackLang(e.value == 'English')}
                                options={options}
                            />
                        </div>

                        <div style={{ display: displayErrorComponent ? "block" : "none" }}>
                            <ErrorAlertsComponent errorMsgList={this.state.validationErrMsg} isEng={this.props.isEng} />
                        </div>

                        <h1 className="ontario-h1 ontario-margin-bottom-0-! div-override-margin">
                            {this.props.isEng ? currentSection?.ENUTitle : currentSection?.FRATitle}
                        </h1>
                        {currentSection?.ENUDescription && (
                            <p className="ontario-lead-statement">
                                {this.props.isEng ? currentSection?.ENUDescription : currentSection?.FRADescription}
                            </p>
                        )}
                    </div>
                );
                break;
        }

        return StepperHeader;
    }

    render() {
        const { activeSection } = this.state;

        if (!activeSection) {
            return (
                <div style={{ padding: '20px', textAlign: 'center', color: '#666' }}>
                    <h4>No section found for step {this.props.stepIndex + 1}</h4>
                    <p>Please check if this step exists in your form.</p>
                </div>
            );
        }

        let stepperContent = [];
        let stepperBody = [];

        stepperContent.push(
            <HelmetComponent
                key="helmet"
                title={this.props.isEng ? activeSection.ENUTitle : activeSection.FRATitle}
            />
        );

        stepperContent.push(this.stepperHeaderGeneration());

        if (activeSection.CustomizedReviewPage) {
            stepperContent.push(
                <CustomizedSummaryComponent
                    key="customized-summary"
                    programContainer={this.state.programContainer}
                    isEng={this.props.isEng}
                    activesteps={new Set<number>([this.props.stepIndex])}
                    style={activeSection.CustomizedSummaryProps?.customizedSummaryStyle || activeSection.CustomizedStyle}
                    callback={(programContainer) => this.handleFormCallback(programContainer)}
                    callbackStepIndex={(index) => this.handleSummaryStepIndex(index)}
                    confirmationVisible={this.state.confirmationVisible}
                    summaryVisible={this.state.summaryVisible}
                    setStateProp={this.handleSummaryState}
                    transactionId={this.state.transactionId}
                    submissionError={this.state.submissionError}
                    showDownloadSummary={this.state.showDownloadSummary}
                    applicationType={this.state.applicationType}
                    renewType={this.state.renewType}
                    currentCustomizedReviewSection={activeSection}
                />
            );

            return (
                <div className="form-step-preview" style={{ width: '100%' }}>
                    {stepperContent}
                </div>
            );
        }

        let optionsFieldValue = new Map<string, string>();
        activeSection.ListOfFormSubSections.forEach(formSubSection => {
            this.sectionOptionsFieldValue(formSubSection, optionsFieldValue);
        });

        const subsectionNumber = activeSection.ListOfFormSubSections.filter(sub => sub.Visible != false).length;
        activeSection.ListOfFormSubSections
            .sort((a, b) => a.Sequence - b.Sequence)
            .forEach((subSection, subSectionIndex) => {
                if (Utils.isNullOrEmpty(subSection.Visible) || subSection.Visible) {
                    let subsectionComponent = (
                        <SubSectionComponent
                            key={'sub_' + subSection.Id + '_' + subSectionIndex}
                            isEng={this.props.isEng}
                            activeSubSection={subSection}
                            optionsFieldValue={optionsFieldValue}
                            editable={true}
                            callbackGeneratePdf={() => {}}
                            callback={(programContainer) => {
                                // Use the working callback handler
                                this.handleFormCallback(programContainer);
                            }}
                            onBusyChange={(isBusy) => {
                                if (this.props.onBusyChange) {
                                    this.props.onBusyChange(isBusy);
                                }}}
                            callbackValidate={(errors) => {
                                this.setState({ validationErrMsg: errors });
                            }}
                            callbackStepIndex={() => { }}
                        />
                    );

                    if (subsectionNumber > 1) {
                        stepperBody.push(
                            <div
                                key={`subsection-container-${subSectionIndex}`}
                                style={{
                                    background: subSection.CanBeDuplicate ? colour.systemLightGrey : colour.background,
                                    padding: subSection.CanBeDuplicate ? "40px" : "0",
                                    marginTop: "40px"
                                }}
                            >
                                {subsectionComponent}
                            </div>
                        );
                    } else {
                        stepperBody.push(
                            <div key={`subsection-${subSectionIndex}`}>
                                {subsectionComponent}
                            </div>
                        );
                    }
                }
            });

        stepperContent.push(
            <div
                key="stepper-body"
                style={{
                    width: '100%',
                    maxWidth: '1200px',
                    margin: '0 auto',
                    padding: '0 20px'
                }}
            >
                {stepperBody}
            </div>
        );

        return (
            <div className="form-step-preview" style={{ width: '100%' }}>
                {stepperContent}
            </div>
        );
    }
}
